<div class="box-border flex w-full flex-col bg-inherit text-base">
  @let hasError = ngControl.errors && ngControl.touched;
  @let showTemplateOption = !!template();
  <div
    class="relative flex w-full flex-col bg-inherit"
    [ngClass]="{
      'gap-4': hasBorder(),
      'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    }">
    @for (option of options(); track $index; let index = $index) {
      <label
        [attr.data-testid]="id() + index | appendTestId: 'label'"
        class="flex cursor-pointer items-center bg-inherit"
        [ngClass]="{
          'border-input-ring rounded-lg border-1 p-6': hasBorder(),
          'px-3 py-2': !hasBorder(),
          'pointer-events-none cursor-not-allowed!':
            ngControl.control!.disabled,
        }"
        [ngStyle]="{
          borderRadius: borderRounding(),
          borderColor: hasBorder()
            ? corporateDesignService.primaryBorderColor()
            : '',
        }">
        <input
          (click)="selectOption(option)"
          [attr.data-testid]="id() + index | appendTestId: 'input'"
          [id]="id() | appendTestId: index + ''"
          [checked]="
            ngControl.control!.value ===
            (option | toSelectOptionAttribute: valueAttribute())
          "
          [value]="option | toSelectOptionAttribute: valueAttribute()"
          type="radio"
          class="text-input-focus border-input pointer-events-none h-5 w-5"
          [ngClass]="{
            'border-input-error text-input-error!': hasError,
            'cursor-not-allowed': ngControl.control!.disabled,
          }"
          [ngStyle]="{
            color: ngControl.disabled
              ? siteContextService.isShopContext()
                ? corporateDesign().primaryBorderColor
                : ''
              : inputSelectedColor(),
            borderColor:
              (ngControl.control!.value === option
              | toSelectOptionAttribute: valueAttribute())
                ? inputSelectedColor()
                : '',
          }"
          [name]="id() + index" />
        @if (showTemplateOption) {
          <ng-container
            *ngTemplateOutlet="
              template()!;
              context: { data: option, index: index }
            "></ng-container>
        } @else {
          <span
            class="pl-2"
            [ngStyle]="{
              color: borderAndLabelColor(),
            }"
            [attr.data-testid]="id() + index | appendTestId: 'option'"
            >{{ option | toSelectOptionAttribute: name() }}</span
          >
        }
      </label>
    }
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
